import React, { useState } from "react";
import {
  Form,
  Button,
  Col,
  Container,
  OverlayTrigger,
  Popover,
  Row,
} from "react-bootstrap";
import Select from "react-select";
import {
  IRRIGATION_COMPANIES,
  CUSTOM_WELL_FORM_SELECT_STYLES,
  DATE_FORMAT,
  EMPTY,
} from "../../../configurations/Constants";
import { DayPicker } from "react-day-picker";
import { format, isValid } from "date-fns";
import {
  SELECT_IRRIGATION_COMPANY,
  SELECT_DATE,
} from "../../../configurations/MessageConstants";

function TesterInfo(props) {
  const [validated, setValidated] = useState(false);
  const [datePopoverOpen, setDatePopoverOpen] = useState(false);

  const saveAndContinue = (event) => {
    const form = event.currentTarget;
    if (
      props.inputValues.irrigationCompany &&
      props.inputValues.dateTested &&
      form.checkValidity() === true
    ) {
      event.preventDefault();
      props.nextStep();
    } else {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
  };

  const handleSelectDate = (date) => {
    props.handleDateChange(date);
    setDatePopoverOpen(false);
  };

  return (
    <Container>
      <br></br>
      <h3 className="mt-2">Tester Information</h3>
      <hr />
      <Form noValidate validated={validated} onSubmit={saveAndContinue}>
        <div className="well-test-form-body">
          <Row>
            <Form.Group as={Col} controlId="formIrrigationCompany" md={6}>
              <Form.Label className="label required-field">
                Irrigation Company
              </Form.Label>
              <Select
                name="irrigationCompany"
                options={IRRIGATION_COMPANIES}
                isClearable={true}
                className={
                  validated && !props.inputValues.irrigationCompany
                    ? "well-test-form-validation"
                    : validated && props.inputValues.irrigationCompany
                    ? "well-test-form-validation-success"
                    : EMPTY
                }
                styles={CUSTOM_WELL_FORM_SELECT_STYLES}
                onChange={props.handleIrrigatioCompanyChange}
                value={props.inputValues.irrigationCompany}
                placeholder="-- Select Irrigation Company --"
              />
              <span className="well-test-form-validation-message">
                {validated && !props.inputValues.irrigationCompany
                  ? SELECT_IRRIGATION_COMPANY
                  : EMPTY}
              </span>
            </Form.Group>

            <Form.Group as={Col} controlId="formDateTested" md={6}>
              <Form.Label className="label required-field">
                Date Tested
              </Form.Label>
              <OverlayTrigger
                trigger="click"
                placement="top"
                show={datePopoverOpen}
                onToggle={setDatePopoverOpen}
                overlay={
                  <Popover id="popover" style={{ maxWidth: "650px" }}>
                    <Popover.Body>
                      <DayPicker
                        numberOfMonths={1}
                        mode="single"
                        selected={props.inputValues.dateTested}
                        onSelect={handleSelectDate}
                      />
                    </Popover.Body>
                  </Popover>
                }
                rootClose
              >
                <Form.Control
                  className={`well-test-form-date-picker ${
                    validated && !props.inputValues.dateTested
                      ? "well-test-form-validation"
                      : validated && props.inputValues.dateTested
                      ? "well-test-form-validation-success"
                      : EMPTY
                  }`}
                  type="text"
                  placeholder="--Select a date--"
                  value={
                    isValid(props.inputValues.dateTested)
                      ? format(props.inputValues.dateTested, DATE_FORMAT)
                      : EMPTY
                  }
                  readOnly
                />
              </OverlayTrigger>
              <span className="well-test-form-validation-message">
                {validated && !props.inputValues.dateTested
                  ? SELECT_DATE
                  : EMPTY}
              </span>
            </Form.Group>
          </Row>

          <Row>
            <Form.Group as={Col} controlId="formPersonCompletingTest" md={6}>
              <Form.Label className="label">
                Person completing the test
              </Form.Label>
              <Form.Control
                type="text"
                defaultValue={props.inputValues.personCompletingTest}
                name="personCompletingTest"
                onChange={props.handleChange}
                autoComplete="off"
              />
            </Form.Group>

            <Form.Group as={Col} controlId="formLicense" md={6}>
              <Form.Label className="label">License#</Form.Label>
              <Form.Control
                type="text"
                defaultValue={props.inputValues.license}
                name="license"
                onChange={props.handleChange}
                autoComplete="off"
              />
            </Form.Group>
          </Row>
        </div>
        <Button
          variant="primary"
          type="submit"
          className="well-test-only-next-btn"
        >
          Next
        </Button>
      </Form>
    </Container>
  );
}

export default TesterInfo;
